<template>
  <div v-if="isMobile" class="tw-relative tw-top-0 tw-left-0">
    <div
      @click="mobileVisible = true"
      class="tw-pt-[65px] tw-pl-[57%] md:tw-hidden"
    >
      <div>
        <div class="minimenu-line"></div>
        <div class="minimenu-line tw-my-[8px]"></div>
        <div class="minimenu-line"></div>
      </div>
    </div>
    <Transition name="fade">
      <div
        v-if="mobileVisible"
        class="tw-fixed tw-top-0 tw-left-0 tw-w-full tw-h-full tw-z-20 tw-bg-mainbg1 tw-opacity-70"
      ></div>
    </Transition>
    <Transition name="slide">
      <div
        v-if="mobileVisible"
        class="sf-menu tw-fixed tw-top-0 tw-z-20 tw-w-[360px] tw-right-[0px] tw-h-full tw-bg-primary tw-text-center tw-text-[2rem]"
      >
        <div
          class="tw-text-mainbg1 tw-pt-[60px] tw-pb-[20px] tw-px-[36px] tw-text-right md:tw-hidden"
        >
          <CloseX size="38px" @click="mobileVisible = false" />
        </div>
        <MainMenuItems />
      </div>
    </Transition>
  </div>
  <div
    v-else
    class="tw-bg-mainbg1 tw-text-left tw-text-lg tw-border-solid tw-border-y-4 tw-border-primary tw-py-[16px] tw-font-bold"
  >
    <MainMenuItems />
  </div>
</template>
import MainMenuItems from './MainMenuItems.vue';

<style scoped lang="postcss">
.minimenu-line {
  @apply tw-bg-main1dark tw-w-[38px] tw-h-[4px] tw-rounded-full;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}
.slide-enter-from,
.slide-leave-to {
  /* opacity: 0; */
  right: -370px;
}
</style>

<script lang="ts">
import { defineComponent } from "vue";
import CloseX from "../ui/CloseX.vue";
import MainMenuItems from "./MainMenuItems.vue";

export default defineComponent({
  components: { CloseX, MainMenuItems },
  data() {
    return {
      colorsMenuVisible: false,
      isMobile: false,
      mobileVisible: false,
    };
  },
  mounted() {
    window.addEventListener("resize", this.checkScreen);
    this.checkScreen();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreen);
  },
  methods: {
    checkScreen() {
      this.isMobile = window.innerWidth < 768;
    },
  },
  watch: {
    $route() {
      this.mobileVisible = false;
    },
  },
});
</script>
